export const JWEB_EVENTS = {
  CLOSE: 'Close',
  JARVIS_FINISHED: 'jarvisEventFinished',
  CLEANUP_ACCOUNT_DELETION: 'CleanupAccountDeletion'
};
